import authentication from '@/modules/apies/authentication'
import user from '@/modules/apies/user/user'
import userrole from '@/modules/apies/user/userrole'
import userpermission from '@/modules/apies/user/userpermission'
import usertoken from '@/modules/apies/user/usertoken'
import country from '@/modules/apies/country'
import city from '@/modules/apies/city'
import airport from '@/modules/apies/airport'
import airline from '@/modules/apies/airline'
import hotel from '@/modules/apies/hotel'
import blog from '@/modules/apies/blog/blog'
import blogcategory from '@/modules/apies/blog/blogcategory'
import tour from '@/modules/apies/tour'
import tourcategory from '@/modules/apies/tourcategory'
import order from '@/modules/apies/order'
import banner from '@/modules/apies/banner'
import zaercard from '@/modules/apies/zaercard'

export default {
  authentication,
  user,
  userrole,
  userpermission,
  usertoken,
  country,
  city,
  airport,
  airline,
  hotel,
  blog,
  blogcategory,
  tour,
  order,
  tourcategory,
  banner,
  zaercard,
}
